import * as Cesium from "cesium";
import {
  AssetTypeEnum,
  CesiumStateEnum,
  Map3DObjectListDto,
} from "~/api/GeneratedApi";
import {
  imageryToCesiumMapItem,
  terrainToCesiumMapItem,
} from "./dataConverters";

export function map3dObjectsToCesium(
  viewer: Cesium.Viewer,
  map3dObjects: Map3DObjectListDto[],
): void {
  // Separate items to terrain and imagery
  // Only add completed items
  const imageryItems = map3dObjects.filter(
    (o) =>
      o.assetTypeId === AssetTypeEnum.IMAGERY &&
      o.stateId === CesiumStateEnum.COMPLETE,
  );
  const terrainItems = map3dObjects.filter(
    (o) =>
      o.assetTypeId === AssetTypeEnum.TERRAIN &&
      o.stateId === CesiumStateEnum.COMPLETE,
  );
  imageryItems.forEach((m) => {
    // Convert to internal type
    const conv = imageryToCesiumMapItem(m);

    // Update or add
    const entity = viewer.entities.getById(conv.mapId);
    if (entity) {
      entity.properties = new Cesium.PropertyBag({
        ...conv,
      });
    } else {
      viewer.entities.add({
        id: conv.mapId,
        properties: new Cesium.PropertyBag({
          ...conv,
        }),
      });
    }
  });
  terrainItems.forEach((m) => {
    // Convert to internal type
    const conv = terrainToCesiumMapItem(m);

    // Update or add
    const entity = viewer.entities.getById(conv.mapId);
    if (entity) {
      entity.properties = new Cesium.PropertyBag({
        ...conv,
      });
    } else {
      viewer.entities.add({
        id: conv.mapId,
        properties: new Cesium.PropertyBag({
          ...conv,
        }),
      });
    }
  });
}
